namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_vk_lists_creating, {
		
		gap: $mol_gap.block,

		Content: {
			gap: $mol_gap.block,
			align: {
				items: 'flex-start'
			},
		},

		Add_block: {
			align: {
				items: 'flex-end'
			},
		},

		Add: {
			margin: $mol_gap.text,
		},

		Group: {
			position: 'relative',
		},

		Remove: {
			position: 'absolute',
			top: '-1.25rem',
			right: '-1.25rem',
			color: 'red'
		},

		Creating_list: {
			gap: $mol_gap.block,
			padding: $mol_gap.block,
		},

		Save: {
			margin: $mol_gap.block,
		},
		
	} )
	
}
